import React from 'react';

import { ClassName, GADataType } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';

import { PureTooltipIconButtonHelper } from '../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';
import { words } from '../../../../../locales/keys';

interface ProductSelectButtonProps {
  handleToggleSelected: () => void;
  iconClassName?: ClassName;
  isSelected: boolean;
  selectedClassName: ClassName;
  selectedIcon?: IconsEnum;
  unselectedClassName: ClassName;
  unselectedIcon?: IconsEnum;
}

function ProductSelectButton({
  dataGa,
  handleToggleSelected,
  iconClassName,
  isSelected,
  selectedClassName,
  selectedIcon,
  unselectedClassName,
  unselectedIcon
}: ProductSelectButtonProps & GADataType) {
  return (
    <PureTooltipIconButtonHelper
      className={isSelected ? selectedClassName : unselectedClassName}
      dataGa={dataGa}
      i18nText={isSelected ? words.selected : words.select}
      icon={isSelected ? selectedIcon || IconsEnum.CHECK : unselectedIcon}
      iconClassName={iconClassName || 'h-4 w-4'}
      tooltipI18nText={words.selectToAddToTheProject}
      i18nTextClassName="inline"
      tooltipPlacement={TooltipPlacement.TOP}
      onClick={handleToggleSelected}
    />
  );
}

export default ProductSelectButton;
